import { SubscriptionEnvironment } from "../identifiers";
import { Schema } from "effect";
export const Status = Schema.Struct({
    environments: Schema.Record({
        key: SubscriptionEnvironment.Schema,
        value: Schema.Struct({
            valid: Schema.Boolean,
            keys: Schema.Record({
                key: Schema.String,
                value: Schema.Struct({
                    valid: Schema.Boolean
                })
            }),
            metadata: Schema.optional(Schema.Any)
        })
    })
});
